import { AnswerButton } from '../AnswerButton/AnswerButton'
import { useTaskHomeWork } from '../hooks/useTaskHomeWork';
import { useEffect, useMemo, useState } from 'react';
import { jsonConvert } from '@/helpers/jsonConvert';
import { formateTime } from '@/helpers/formateTime';
import { useVideoState } from '../hooks/useVideoState';
import { VideoAnswer } from '../VideoAnswer/VideoAnswer';
import s from './DrawingImage.module.css'
import { useCanvas } from '@common/DrawingImage/canvas/useCanvas';
import DrawingImageComponent from '@common/DrawingImage';
import { FileViewer } from '../components/common/FileViewer';
import useRoles from '@/hooks/useRoles';
import classNames from 'classnames';
import Image from '@UI/New/Image';

export const DrawingImage = ({ type, ...props }) => {
  switch (type) {
    case 'decided': return <Decided {...props} />
    case 'correction': return <Correction {...props} />
    default: return <Task type={type} hist={props?.hist}  {...props} />
  }
}
const Correction = ({homeTaskFiles}) => {
  const images = homeTaskFiles?.filter((el) => el.type === 'image-drawing')
  return (
    <div className={s.wrapper}>
      <div className={s.correctionText}>Нарисуйте на изображении:</div>
      {
        images?.map((image) => {
          return(
            <Image width={image?.size ?? 100} path={process.env.REACT_APP_PATH_FILE + image?.file_path} />
          )
        })
      }
    </div>
  )
}

const Decided = ({ userRole, ...props }) => {
  const { isSeminarian } = useRoles();

  const { video, videoType } = useVideoState(
            {
                video_source_type: props?.params?.result?.video_source_type,
                video_solution: props?.params?.result?.video_solution,
                video_solution_platform_media: props?.params?.result?.video_solution_platform_media,
                video_solution_iframe: props?.params?.result?.video_solution_iframe
            }
  );
  
  const answer = props?.params?.result?.answer
  const decidedRight = props?.params?.result?.decided_right
  const files = props?.params?.result?.answer_files ?? []

  //
  const {
    canvasRef,
    canvasState,
    canvasOperations,
    saveImage,
    resetCanvas,
    canvasStyle
  } = useCanvas({
    saveImageParams: {
      initialText: 'Идет отправка изображения',
      successText: 'Изображение успешно добавлено во вложения'
    }
  });
  const {
    imageUrl, setImageUrl, loading, setChangeImage, changeImage,
    brushColor, setBrushColor, brushWidth, setBrushWidth,
    isTextRegim, setIsTextRegim, canvasFont, isSaving,
    showCanvasText, canvasText, setCanvasText,
    xY
  } = canvasState;

  const {
    startDrawing, draw, stopDrawing, addText,
    undoLastAction, increaseScale, decreaseScale,
    saveCanvasText, changeCanvasFont
  } = canvasOperations;

  const handleSaveImage = {
      f: () => {
      saveImage((blob) => 
        props.teacherAnswer.addCommentFile({
          'comment_files': [blob],
          'work_id': props.homeWork_id,
          'task_id': props.id,
        }).then(res => {
          if (res.data.data?.length > 0) {
            props.updateList(res.data.data);
          }
        })
      );
    },
    text: 'Отправить изображение учащемуся' 
  }
  //код для конваса заканчивается здесь
  
  return <div className={s.answerWrap}>
    <span className={classNames(s.capsuleLeft, { [s.red]: decidedRight !== 1 && !props?.hideSolutionCorrectness })}>{userRole === 'children' ? 'Ваш ответ' : 'Ответ учащегося'}</span>
    <FileViewer 
        classNameA={s.capsuleRight}
        classNameImg={s.editable}
        {...{loading, answer, changeImage, setImageUrl}} />
    
    {
      files.map(file => (
        <FileViewer 
            classNameA={s.capsuleRight}
            classNameImg={s.editable}
            answer={file.path} {...{loading, changeImage, setImageUrl}} />
        ))
    }

    { isSeminarian && <button onClick={() => { setChangeImage((prevValue) => !prevValue) }} className='backgroundNewGrey backgroundNewYellow'>
          {changeImage ? 'Свернуть' : 'Изменить изображение и отправить ученику'}
        </button>
    }

    <DrawingImageComponent {
          ...{
            changeImage,
            imageUrl,
            setBrushColor,
            setBrushWidth,
            brushWidth,
            setIsTextRegim,
            changeCanvasFont,
            isSaving,
            isTextRegim,
            showCanvasText,
            saveCanvasText,
            canvasFont,
            startDrawing,
            draw,
            brushColor,
            undoLastAction,
            increaseScale,
            canvasRef,
            decreaseScale,
            handleSaveImage,
            loading,
            resetCanvas,
            stopDrawing,
            addText,
            canvasStyle,
            xY,
            canvasText,
            setCanvasText
          }
        } />
    
    {props?.params?.result?.time_spent &&
      <div className={s.estimation}>
        <span className={s.boobleSpent}>Потрачено время</span>
        <span className={s.boobleSpent}> {formateTime(props?.params?.result?.time_spent)}</span>
      </div>
    }
    {video && <VideoAnswer video={video} videoType={videoType} />}
    </div>
  
}

const Task = ({ hist, params, userRole, ...props }) => {
    const images = props?.homeTaskFiles?.filter((el) => el.type === 'image-drawing')
    const {
        canvasRef,
        canvasState,
        canvasOperations,
        saveImage,
        resetCanvas,
        canvasStyle
    } = useCanvas();
    const {
        imageUrl, setImageUrl, loading, setChangeImage, changeImage,
        brushColor, setBrushColor, brushWidth, setBrushWidth,
        isTextRegim, setIsTextRegim, canvasFont, isSaving,
        showCanvasText, canvasText, setCanvasText, xY, history
    } = canvasState;

    const [isEditing, setIsEditing] = useState(false);
    const enableEditing = () => {
      answer.set('')
      params.setStatRowValues?.((prev) => {
          return prev.map((item) => (item.id === props.id ? {...item, value: 0} : item))
      })
      setIsEditing(true);

      const imageUrl = process.env.REACT_APP_PATH_FILE + '/' + images[0]?.file_path;
      setImageUrl(imageUrl)
      setChangeImage(true)
    };

    const { onAnswer, answer, status, hint, video, videoType } = useTaskHomeWork({...params, typeTask: 'drawing-image'}, {...props, type: 'file'}, true, [], false, setIsEditing);

    useEffect(() => {
        if(history?.length > 1) {
                saveImage((blob) => {
                    answer.set(blob)
                }
            );            
        }
    }, [history])

    const {
        startDrawing, draw, stopDrawing, addText,
        undoLastAction, increaseScale, decreaseScale,
        saveCanvasText, changeCanvasFont
    } = canvasOperations;
  
    useEffect(()=>{
        if(images?.length === 1) {
            if(changeImage || loading) return;
            const imageUrl = process.env.REACT_APP_PATH_FILE + '/' + (!!answer?.get ? answer?.get : images[0]?.file_path); 
            setImageUrl(imageUrl)
            setChangeImage(true)
        }
    }, [images?.length])

    useEffect(()=>{
      if(status == 0 || status == 2 || isEditing){
        setChangeImage(true)
      }
      else{
        resetCanvas()
        setChangeImage(false)
      }
    }, [status, images?.length, answer.get, isEditing])

    return <div>
        {/* <div className={s.text}>Нарисуйте на изображении</div> */}
        <DrawingImageComponent {
          ...{
            changeImage,
            imageUrl,
            setBrushColor,
            setBrushWidth,
            brushWidth,
            setIsTextRegim,
            changeCanvasFont,
            isSaving,
            isTextRegim,
            showCanvasText,
            saveCanvasText,
            canvasFont,
            startDrawing,
            draw,
            brushColor,
            undoLastAction,
            increaseScale,
            canvasRef,
            decreaseScale,
            loading,
            resetCanvas,
            stopDrawing,
            addText,
            canvasStyle,
            xY,
            canvasText,
            setCanvasText,
            // canvasManageHide: status != 0 && status != 2,
            showResetCanvas: false
          }
        } />
        {
          !changeImage && typeof answer?.get === 'string' && <Image width={images[0]?.size ?? 100} path={process.env.REACT_APP_PATH_FILE + answer?.get} />
        }
        <div className={s.answerButtonWrapper}>
          <AnswerButton 
            hideSolutionCorrectness = {props?.hideSolutionCorrectness} 
            hintForChild={params.hintForChild} 
            hintAfterAllAttempts={props.hint_after_all_attempts} 
            {...{ status, onAnswer, hint, video, videoType, isEditing}} />
          {!isEditing && status > 4 && userRole !== 'parent' && (
            <button style={{marginTop:'auto'}} className='btn' onClick={enableEditing}>
              Изменить ответ
            </button>
          )}
        </div>
    </div>
  
}